import { isDebugMode } from '@/lib/utils'
import { capture as captureImpl, identifyUser as identifyUserImpl } from './client'
import { captureDebug, identifyUserDebug } from './client/capture'

export const capture = isDebugMode() ? captureDebug : captureImpl
export const identifyUser = isDebugMode() ? identifyUserDebug : identifyUserImpl

export { PostHogProvider } from './client'
export type * from './types'
